<template>
    <!-- One test per line — readable even in a narrow sidebar column -->
    <div class="space-y-2.5">
        <div
            v-for="assessment in assessments"
            :key="assessment.type"
            class="rounded-xl border border-gray-200 bg-white p-3 dark:border-default dark:bg-surface-card"
        >
            <div class="flex items-start justify-between gap-3">
                <div class="flex min-w-0 items-center gap-2">
                    <img
                        v-if="getCover(assessment.type)"
                        alt=""
                        class="size-9 shrink-0 object-contain"
                        height="36"
                        loading="lazy"
                        :src="getCover(assessment.type)"
                        width="36"
                    />
                    <span v-else-if="assessment.icon" class="shrink-0 text-xl leading-none">{{ assessment.icon }}</span>
                    <h4 class="truncate text-sm font-semibold text-gray-900 dark:text-txt-body">
                        {{ assessment.title }}
                    </h4>
                </div>
                <div class="shrink-0 text-right">
                    <span class="text-base font-bold text-primary">{{ assessment.primaryLabel }}</span>
                    <span
                        v-if="assessment.secondaryLabel"
                        class="ml-1 text-xs text-gray-600 dark:text-txt-body"
                    >
                        {{ assessment.secondaryLabel }}
                    </span>
                </div>
            </div>

            <p v-if="assessment.summary" class="mt-2 text-sm text-gray-700 dark:text-txt-body">
                {{ assessment.summary }}
            </p>

            <ul v-if="assessment.details?.length" class="mt-2 flex flex-wrap gap-1.5">
                <li
                    v-for="(detail, index) in assessment.details"
                    :key="index"
                    class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600 dark:bg-subtle dark:text-txt-body"
                >
                    {{ detail }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { testCoverImage } from '#shared/sebapoznanie/testTree'
import type { SharedAssessment } from '#shared/types/JobRequest'
import type { SurveyTypes } from '#shared/types/Survey'
import { useSebapoznanieTests } from '@/composables/useSebapoznanieTests'

const { getTestBySurveyType } = useSebapoznanieTests()

function getCover(type: SurveyTypes): string {
    const slug = getTestBySurveyType(type)?.slug
    return slug ? testCoverImage(slug) : ''
}

defineProps<{
    assessments: SharedAssessment[]
}>()
</script>
